import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Box, Card, CardMedia, Typography, CardActionArea, useTheme, useMediaQuery } from '@mui/material';
import { Autoplay, Navigation } from 'swiper/modules';
import { aboutImages } from '../../utils/BeadsData';


const AboutSectionCarousel = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={15}
            slidesPerView={3}
            // centeredSlides={true}
            loop={true}
            autoplay={isMobile ? { delay: 2500, disableOnInteraction: false } : true }
            navigation={!isMobile}
            breakpoints={{
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            }}
        >
            {aboutImages.map((item, index) => (
                <SwiperSlide key={index}>
                    <Card sx={{
                        width: isMobile ? '100' : 350,
                        height: 350,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '1rem',
                        transition: 'transform .3s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.03)',
                        },
                        mx: 'auto',
                    }}
                    >
                        <CardActionArea href={item.link} sx={{ width: '100%', height: '100%' }}
                        // transition: 'transform 0.5s ease-in-out',
                        >
                            <CardMedia
                                component="img"
                                image={item.src}
                                alt={item.alt}
                                sx={{
                                    height: '100%',
                                    width: '100%',
                                    objectFit: 'cover',
                                    // borderRadius: '.5rem',
                                    // transition: 'transform 0.5s ease-in-out',
                                }}
                            />
                            <Box sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                //  justifyContent: 'center',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                color: 'white',
                                textAlign: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            }}>
                                <Typography variant="h5" component="div" sx={{ fontWeight: 'bolder', color: '#ffa500', mt: 2, mb: 1 }}>
                                    {item.title}
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'white', mb: 2, textAlign: 'center', px: 1 }}>
                                    {item.description}
                                </Typography>
                            </Box>
                        </CardActionArea>
                    </Card>
                </SwiperSlide>
            ))}
        </Swiper>

    );
};

export default AboutSectionCarousel;
